import { ScheduleTask, DatabaseScheduleTask } from '../schedule';
import { TaskName } from '../tasks';

export enum ScheduleType {
    config = 'config',
    database = 'database',
}

export type ScheduleGetQuery = {
    type: ScheduleType;
    task: TaskName;
};

export type ScheduleGetResponse = Array<
    ScheduleTask | (Omit<DatabaseScheduleTask, '_id'> & { _id: string })
>;
